import Link from '@components/v2/ui/Link/Link';
import Modal from '@components/v2/ui/Modal/Modal';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { Image } from 'lucide-react';
import LangEnum from '../../../../../../lang/LangEnum';
import { CatalogProductsTestIds } from '../../../../../../utils/testIds/CatalogProducts.testIds';
import { useTranslation } from '../../../../../translation/TranslationContext';
import {
  CATALOG_BANNERS_MAX_ITEMS,
  CATALOG_CREATION_BANNER_FIELDS,
  CATALOG_MEDIA_GUIDE_URL,
} from '../../../../creation/catalogCreationMedia.consts';
import CatalogBannersModalField from './components/CatalogBannersModalField';
import useCatalogBannersModal from './hooks/useCatalogBannersModal';

interface CatalogBannersModalProps {
  catalogId: string;
  isOpen: boolean;
  onClose: () => void;
}

const CatalogBannersModal = ({ catalogId, isOpen, onClose }: CatalogBannersModalProps) => {
  const { translate } = useTranslation();
  const { isSaving, isSaveDisabled, getSavedUrls, handleFieldChange, reset, submit } =
    useCatalogBannersModal({ catalogId, onClose });

  return (
    <Modal
      isOpen={isOpen}
      size="expanded"
      testId={CatalogProductsTestIds.BANNERS_MODAL}
      onClose={onClose}
      onExited={reset}
      header={{ title: LangEnum.CATALOGS_MANAGE_BANNERS, icon: Image }}
      footer={{
        primaryAction: {
          label: LangEnum.GLOBAL_SAVE,
          isDisabled: isSaveDisabled,
          isLoading: isSaving,
          onClick: submit,
        },
      }}
    >
      <Stack sx={{ gap: 2 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {`${translate(LangEnum.CATALOGS_BANNERS_MODAL_DESCRIPTION, { maxItems: String(CATALOG_BANNERS_MAX_ITEMS) })} `}
          <Link href={CATALOG_MEDIA_GUIDE_URL} color="text.primary" underline="always">
            {translate(LangEnum.GLOBAL_LEARN_MORE)}
          </Link>
          .
        </Typography>

        {CATALOG_CREATION_BANNER_FIELDS.map((config) => (
          <CatalogBannersModalField
            key={config.field}
            config={config}
            savedUrls={getSavedUrls(config.field)}
            onChange={(state) => handleFieldChange(config.field, state)}
          />
        ))}
      </Stack>
    </Modal>
  );
};

export default CatalogBannersModal;
